export const pieSectionTransition = { duration: 0.2 };
